import { render } from "./StickyDownload.vue?vue&type=template&id=5cae5e6e&scoped=true"
import script from "./StickyDownload.vue?vue&type=script&lang=js"
export * from "./StickyDownload.vue?vue&type=script&lang=js"

import "./StickyDownload.vue?vue&type=style&index=0&id=5cae5e6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cae5e6e"]])

export default __exports__